import { Box } from '@mui/material';
import { ResponsiveHeatMap } from '@nivo/heatmap';
import ChartSection from '../shared/ChartSection';
import ChartTooltip from '../shared/ChartTooltip';
import useNivoTheme from '../shared/useNivoTheme';

export default function PartySectorHeatmap({ data }) {
    const { theme } = useNivoTheme();
    if (!data?.data || data.data.length === 0) return null;

    const keys = data.keys.filter(k => k !== 'Unknown');
    const heatmapData = data.data.map(row => ({
        id: row.id,
        data: keys.map(sector => ({ x: sector, y: row[sector] || 0 })),
    }));

    return (
        <ChartSection
            id="party-sector"
            title="Do Democrats and Republicans trade different sectors?"
            subtitle="Trade volume by party and sector — look for patterns in who trades what"
        >
            <Box sx={{ height: 280 }}>
                <ResponsiveHeatMap
                    data={heatmapData}
                    margin={{ top: 100, right: 40, bottom: 20, left: 110 }}
                    axisTop={{ tickRotation: -45 }}
                    colors={{ type: 'sequential', scheme: 'blues' }}
                    emptyColor="rgba(255,255,255,0.03)"
                    borderRadius={2}
                    borderWidth={1}
                    borderColor="rgba(255,255,255,0.06)"
                    labelTextColor="#ffffff"
                    tooltip={({ cell }) => (
                        <ChartTooltip
                            title={`${cell.serieId} · ${cell.data.x}`}
                            rows={[
                                {
                                    label: 'Trades',
                                    value: cell.data.y.toLocaleString(),
                                    color: cell.color,
                                },
                            ]}
                        />
                    )}
                    theme={theme}
                />
            </Box>
        </ChartSection>
    );
}
